import { useLogged } from "hook/useLogged";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonCta = () => {
  // -------------------------- VAR -----------------------------
  const { logged } = useLogged();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLogged = () => {
    if (logged) {
      return (
        <>
          <a
            href="/bailiff"
            className="bg-accent-500 text-primary-900 hover:text-primary-900 shadow-glow rounded-xl px-8 py-3.5 text-center font-bold transition-all hover:bg-white"
          >
            Tải file Ngay
          </a>
        </>
      );
    }
  };

  const renderUnLogged = () => {
    if (!logged) {
      return (
        <>
          <a
            href="/login"
            className="bg-accent-500 text-primary-900 hover:text-primary-900 shadow-glow rounded-xl px-8 py-3.5 text-center font-bold transition-all hover:bg-white"
          >
            Tải file Ngay
          </a>
        </>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderLogged()}
      {renderUnLogged()}
    </>
  );
};
export default ButtonCta;
